import { jsx as _jsx } from "react/jsx-runtime";
import {} from 'react';
import { cn } from '../lib/utils.js';
export function CountBadge({ count = 0, attn = false, className, ...rest }) {
    return (_jsx("span", { "data-attn": attn ? '' : undefined, className: cn('inline-flex h-5 min-w-5 items-center justify-center whitespace-nowrap rounded-pill bg-line px-1.5 font-mono text-[11px] font-semibold leading-none tabular-nums text-ink-3', 'data-[attn]:bg-warn-soft data-[attn]:text-warn', className), ...rest, children: count }));
}
//# sourceMappingURL=count-badge.js.map